import { render, staticRenderFns } from "./CustomGroupMenu.vue?vue&type=template&id=209579fa&scoped=true"
import script from "./CustomGroupMenu.vue?vue&type=script&lang=js"
export * from "./CustomGroupMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomGroupMenu.vue?vue&type=style&index=0&id=209579fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209579fa",
  null
  
)

export default component.exports